import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancelled() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div className="min-h-[70vh] bg-[#F8FAFC] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md rounded-2xl border border-[#E2E8F0] bg-white p-8 text-center shadow-sm">
        <XCircle size={40} className="mx-auto text-[#94A3B8]" />
        <h1 className="mt-4 text-xl font-bold font-display text-[#0F172A]">Checkout was cancelled</h1>
        <p className="mt-3 text-sm text-[#475569] leading-relaxed">
          No payment was made. You can try again anytime from your dashboard.
        </p>
        {orderId && <p className="mt-3 text-xs text-[#94A3B8]">Reference: {orderId}</p>}
        <Link to="/account/dashboard" className="mt-6 inline-flex items-center justify-center rounded-xl bg-[#0F172A] px-6 py-3 text-sm font-semibold text-white hover:bg-[#1E293B] transition-colors">
          Go to my dashboard
        </Link>
      </div>
    </div>
  );
}
